import { styled } from "styled-components";

const ActionsDivisor = styled.div`
  display: inline-block;
  content: "";
  height: ${({ theme }): string => theme.typography.text.md};
  border-left: 1px solid ${({ theme }): string => theme.palette.gray[300]};
  margin: 0 ${({ theme }): string => theme.spacing[0.125]};
`;

export { ActionsDivisor };
